module.exports = __webpack_public_path__ + "static/media/collections_02.6565bd4d.jpg";